// @flow

import { createSelector } from 'reselect';
import { getEventEntities } from 'modules/event/selector';
import { fromJS } from 'immutable';

const getUmbrellaEventIds = (state: Map<*, *>) => state.getIn([ 'umbrellaHomePage', 'umbrellaEventList' ]);

export const getUmbrellaEvents = createSelector(
  [ getEventEntities, getUmbrellaEventIds ],
  (events, ids) => {
    const list = ids.filter(id => !!id).map(id => events.get(id));

    return fromJS(list);
  },
);

export const isLoadingUmbrellaEvents = (state: Map<*, *>) => state.getIn([ 'umbrellaHomePage', 'loadingUmbrellaEvents' ]);

export const getKeywords = (state: Map<*, *>) => state.getIn([ 'umbrellaHomePage', 'keywords' ]);

export const getLatestKeywords = (state: Map<*, *>) => state.getIn([ 'umbrellaHomePage', 'latestKeywords' ]);

export const getTotalUmbrellaEvents = (state: Map<*, *>) => state.getIn([ 'umbrellaHomePage', 'totalUmbrellaEvents' ]);

export const getEventPageNumber = (state: Map<*, *>) => state.getIn([ 'umbrellaHomePage', 'currentPageNumberEvents' ]);

export const getIsFirstEntry = (state: Map<*, *>) => state.getIn([ 'umbrellaHomePage', 'isFirstEntry' ]);
